import React, { useEffect } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselInicio } from '../../json/carousel';

const Inicio = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='secretaria_logo' >
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Salud.svg")` }}>

              </div>
            </div>
          </div>
          <div className='secretaria_name'>
            <h1>SECRETARÍA DE SALUD</h1>
          </div>
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>La Secretaría de Salud como Dependencia de la Administración Pública Centralizada del Estado de
Hidalgo, tiene a su cargo las atribuciones, facultades y el despacho de los asuntos que expresamente le encomienda
el artículo 39 de la Ley Orgánica de la Administración Pública para el Estado de Hidalgo y las demás
leyes, reglamentos, decretos, convenios de colaboración y coordinación en materia fiscal y administrativa, acuerdos
y otras disposiciones vigentes en el ámbito de su competencia.
<br></br>
La Secretaría ejercerá sus atribuciones de planeación, organización, programación,
presupuestación, dirección, coordinación, control, supervisión, evaluación y ejecución fiscal con base en los
objetivos, políticas, estrategias y prioridades establecidas en el Plan Estatal de Desarrollo.</p>
              <div className='btn_organigrama'>
                {/* <button type="button" className="btn btn-primary">Organigrama</button>
                <button type="button" className="btn btn-primary">Normatividad</button> */}
              </div>
              <div className='secretaria-redes'>
                <a href='https://www.facebook.com/saludhgo' rel="noopener noreferrer" target={"_blank"}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"/>
                  </svg>
                </a>
                <a href='https://twitter.com/Salud_Hidalgo' rel="noopener noreferrer" target={"_blank"}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                  </svg>
                </a>
                {/*<a href=''><i className="fa-brands fa-instagram"></i></a>*/}
              </div>
          </div>
        </div>
        <UltimasNoticias/>
        <div className='row'>
          <div className='col-12'>
            <div className='notes_title'>
              <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
              <hr className='hr-gob'/>
            </div>            
            {
              titular.map((item, index) =>(
                  <div key={ index } className='section_notes'>
                    <div  className='sec_photo'>
                      <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                      </div>
                    </div>
                    <div  key={ index+"c" } className='sec_container'>
                      <div className='sec_name'>
                        <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_function'>
                        <h4>Función de la Secretaria</h4>
                        <p>{ item.funcion }</p>
                        <div className='btn_agenda'>
                          <Link to="Agenda">Conoce la agenda de la  Secretaria</Link>
                        </div>
                      </div>
                    </div>
                  </div>
              ))
            }
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              <iframe title="Ubicación"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3747.0791151348244!2d-98.7631763!3d20.0889794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d05649a034ab85%3A0x1c702c4178511bf8!2sSecretar%C3%ADa+de+Salud+de+Hidalgo!5e0!3m2!1ses!2smx!4v1555966046807!5m2!1ses!2smx"
                      width="100%"
                      height="300"
                      style={{border:0, marginBottom:50}}
                      allowFullScreen>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Inicio
